import ErrorPage from "next/error";
import Head from "next/head";
import CelebrityImage from "../../components/celebrity-image";
import ContentNotFound from "../../components/ContentNotFound";
import Layout from "../../components/layout";
import CommonBlogPreview from "../../components/Layout/common-blog-preview";
import SidebarPWA from "../../components/PWA/SidebarPWA";
import SEOMeta from "../../components/SEOMeta";
import SidebarBlog from "../../components/sidebar-blog-post";
import SearchForm from "../../components/sidebar/SearchForm";
import {
  getAllAuthorWithSlug,
  getAuthorData,
  getLatestBlogs,
  resolveAll,
} from "../../lib/api";

export default function Category({ authors, sidebarLatestPosts }) {
  if (!authors) return <ErrorPage statusCode={404} />;

  const latestPosts = sidebarLatestPosts.edges;
  const author = authors[0].node;
  const authorPosts = authors[0].node.posts;

  if (!author) return <ErrorPage statusCode={404} />;

  return (
    <Layout>
      <Head>
        <title>{author.seo.title}</title>
        <SEOMeta seoData={author.seo} type="author" />
      </Head>

      <main className="blog-page-main-sec trending-post-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <header className="row blog-page-dsc mb-4">
                <CelebrityImage
                  firstName={author.name}
                  coverImage={author.avatar}
                  imgWidth={"60"}
                  imgHeight={"80"}
                />

                <h2 className=" page-title text-center mt-3">{author.name}</h2>

                {author.description && (
                  <p className=" text-center mt-3">
                    <div
                      dangerouslySetInnerHTML={{ __html: author.description }}
                    />
                  </p>
                )}
              </header>
            </div>

            <div className="col-lg-8">
              <div className="celebrity-sec-card-whapper mb-5 post-grid-wrapper">
                {authorPosts.edges.map((posts) => (
                  <CommonBlogPreview
                    key={posts.node.slug}
                    title={posts.node.title}
                    categories={posts.node.categories}
                    coverImage={posts.node.featuredImage}
                    date={posts.node.date}
                    slug={posts.node.slug}
                  />
                ))}
                {authorPosts.edges.length <= 0 && <ContentNotFound />}
              </div>
            </div>

            <div className="col-lg-4 mb-5">
              <aside className="aside-bar">
                <SearchForm />
                <hr />

                <SidebarPWA/>
                <hr />

                {latestPosts.length > 0 && (
                  <SidebarBlog posts={latestPosts} title="Recent News" />
                )}
              </aside>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export async function getStaticProps({ params, preview = false, previewData }) {
  if (!params.slug) {
    return;
  }

  const limit = 5;
  const [sidebarLatestPosts, data] = await resolveAll([
    getLatestBlogs(limit, preview),
    getAuthorData(params.slug, preview, previewData),
  ]);

  return {
    props: {
      preview,
      sidebarLatestPosts,
      authors: data.edges,
      slug: params.slug,
    },
    revalidate: 60 * 60 * 24,
  };
}

export async function getStaticPaths() {
  const allAuthor = await getAllAuthorWithSlug();

  return {
    paths: allAuthor.edges.map(({ node }) => `/author/${node.slug}`) || [],
    fallback: true,
  };
}
